import { getFullUrlWithCurrentSubDomain } from 'hubspot-url-utils';
import memoizeOne from 'react-utils/memoizeOne';
import { getPortalId } from '../../../common/utils';
import { getProjectName } from 'nest/common/utils';
export const getIframeSrc = memoizeOne(() => {
  const portalId = getPortalId();
  const hostAppName = encodeURIComponent(getProjectName());
  const hostAppPathName = encodeURIComponent(window.location.pathname);
  const origin = getFullUrlWithCurrentSubDomain();
  const params = new URLSearchParams({
    hostAppName,
    pathname: hostAppPathName
  });
  return `${origin}/chatspot-widget-ui/${portalId}?${params.toString()}`;
});